import type { ComponentType, SVGProps } from 'react'

import AppStoreIcon from '@/assets/icons/app-store-badge.svg'
import GooglePlayIcon from '@/assets/icons/google-play-badge.svg'
import FacebookIcon from '@/assets/icons/tasks-feed/facebook.svg'
import InstagramIcon from '@/assets/icons/tasks-feed/instagram.svg'
import TiktokIcon from '@/assets/icons/tasks-feed/tiktok.svg'
import TypeActionIcon from '@/assets/icons/tasks-feed/type-action.svg'
import TypeCreateIcon from '@/assets/icons/tasks-feed/type-create.svg'
import TypeShareIcon from '@/assets/icons/tasks-feed/type-share.svg'
import TypeWatchIcon from '@/assets/icons/tasks-feed/type-watch.svg'
import XIcon from '@/assets/icons/tasks-feed/x.svg'
import YoutubeIcon from '@/assets/icons/tasks-feed/youtube.svg'
import type { TaskCardCta } from '@/features/tasks/taskCardCta'
import type { ActionTaskPlatform } from '@/features/tasks/types/actionTaskDetail'

import type { TaskCardSocialPlatform } from '../TaskCard/taskCard.constants'

type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>

export const TASK_FEED_TYPE_ICON: Record<TaskCardCta, SvgIcon> = {
  watch: TypeWatchIcon,
  share: TypeShareIcon,
  action: TypeActionIcon,
  create: TypeCreateIcon
}

/** Social network of share / create tasks, or a store of action tasks. */
export type TaskFeedPlatform = TaskCardSocialPlatform | ActionTaskPlatform

export const TASK_FEED_PLATFORM_ICON: Record<TaskFeedPlatform, SvgIcon> = {
  instagram: InstagramIcon,
  tiktok: TiktokIcon,
  youtube: YoutubeIcon,
  x: XIcon,
  facebook: FacebookIcon,
  app_store: AppStoreIcon,
  google_play: GooglePlayIcon
}

export function isTaskFeedPlatform(
  value: string | null | undefined
): value is TaskFeedPlatform {
  return (
    typeof value === 'string' && Object.hasOwn(TASK_FEED_PLATFORM_ICON, value)
  )
}

export const TASK_FEED_PLATFORM_LABEL: Record<TaskFeedPlatform, string> = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  x: 'X',
  facebook: 'Facebook',
  app_store: 'App Store',
  google_play: 'Google Play'
}

export const TASK_FEED_PLATFORM_ORDER = [
  'instagram',
  'tiktok',
  'youtube',
  'x',
  'facebook',
  'app_store',
  'google_play'
] as const satisfies readonly TaskFeedPlatform[]

/** Stores of an action task in the order the card shows them. */
export const TASK_FEED_STORE_ORDER = [
  'google_play',
  'app_store'
] as const satisfies readonly ActionTaskPlatform[]

export type TaskFeedStatusTone =
  | 'warning'
  | 'success'
  | 'error'
  | 'info'
  | 'neutral'

export type TaskFeedStatus = {
  tone: TaskFeedStatusTone
  label: string
}
